import React, { Fragment } from "react";

const LocationItem = ({
  setFilters,
  filters,
  setIsChecked,
  isChecked,
  item,
  index,
}) => {
  return (
    <Fragment>
      <div className="flex-only" key={index}>
        {filters.location === "" && (
          <div>
            <input
              type="checkbox"
              name="location"
              className="job-type"
              value={item.location}
              onChange={(e) => {
                if (!isChecked.location) {
                  setFilters({ ...filters, location: e.target.value });
                  setIsChecked({ ...isChecked, location: true });
                } else {
                  setFilters({ ...filters, location: "" });
                  setIsChecked({ ...isChecked, location: false });
                }
              }}
            />
            <span className="job-type">
              {item.location.city}, {item.location.state}
            </span>
            <br />
          </div>
        )}
        {filters.location === item.location && (
          <div>
            <input
              type="checkbox"
              name="location"
              className="job-type"
              checked
              value={item.location.city}
              onChange={(e) => {
                if (!isChecked.location) {
                  setFilters({ ...filters, location: e.target.value });
                  setIsChecked({ ...isChecked, location: true });
                } else {
                  setFilters({ ...filters, location: "" });
                  setIsChecked({ ...isChecked, location: false });
                }
              }}
            />
            <span className="job-type">
              {item.location.city}, {item.location.state}
            </span>
            <br />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default LocationItem;
